import { render } from "./DeleteExpenseModal.vue?vue&type=template&id=0ef61a98"
import script from "./DeleteExpenseModal.vue?vue&type=script&lang=js"
export * from "./DeleteExpenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__